import React from "react";
import TextField from "material-ui/TextField";

const CTextField = props => (
  <TextField
    InputProps={{
      disableUnderline: true
    }}
    InputLabelProps={{
      shrink: true
    }}
    {...props}
  />
);

export default CTextField;



// WEBPACK FOOTER //
// ./src/uis/CTextField.jsx